import axios from 'axios';

export const AccountSettingsApi = {
  loadRequesterMeta: () => axios.get(
    `/api/public/metadata/requester_short`
  ),
  updateRequesterData: formData => axios.put(
    `/api/public/passport/requester`, formData
  ),
  getUserProfile: username =>
    axios.get(`api:services/nedb-entitlement/api/entlmnt/users/${username}`),
  updateMyChildrenData: childIin => axios.post(`/api/public/integration/zags/update_child/${childIin}`),

};
